module.exports = __webpack_public_path__ + "img/Scrum board_Outline.0e22c274.png";